import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	getMesEqipNoPopup: ({ searchParams, currentPage, pageUnit }) => {
		const queryStr = objectToQuerystring({
			eqipKndCd: searchParams.eqipKndCd,
			mesEqipNm: searchParams.mesEqipNm,
			mesEqipNo: searchParams.mesEqipNo,
			usePlCd: searchParams.usePlCd,
			currentPage,
			pageUnit
		});

		return client
			.get(`${BASE_URL}/comm/commpopup/mesEqipNoPopup/v1/mesEqipNoPopups` + queryStr)
			.then(response => response?.data)
			.catch(error => {
				throw error.response.data;
			});
	}
};
